var render, staticRenderFns
import script from "./CrtSponsor.vue?vue&type=script&lang=js&"
export * from "./CrtSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66945648')) {
      api.createRecord('66945648', component.options)
    } else {
      api.reload('66945648', component.options)
    }
    
  }
}
component.options.__file = "src/views/Configuration/Sponsors/CrtSponsor.vue"
export default component.exports